import React, { useEffect } from 'react'
import MenuIcon from '@mui/icons-material/Menu';
import axios from 'axios';
import { useState } from 'react';
import dayjs from 'dayjs';
import { ConfigProvider, Pagination } from "antd";
import { usePapaParse } from 'react-papaparse';
import { useCSVDownloader } from 'react-papaparse';
import { Flex, Progress } from "antd";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CustomSpinner from '../components/CustomSpinner';
import Select from 'react-select';

function Consents({ serverURL, user, setUser, setShowSideOverlay, socket, onlineUsers }) {

    const [currentPageNumber, setCurrentPageNumber] = useState(1)
    const [globleSearchValues, setGlobleSearchValues] = useState([])
    const [loadingEntries, setLoadingEntries] = useState(true);
    const [entriesLimit, setEntriesLimit] = useState(100)
    const [skipEntries, setSkipEntries] = useState(0)

    const [serviceTypes, setServiceTypes] = useState([]);
    const [serviceProviders, setServiceProviders] = useState([]);

    const [totalEntriesCount, setTotalEntriesCount] = useState(0)

    const allServiceTypes = [
        { value: "counseling", label: "Counseling" },
        { value: "admission", label: "Admission" },
        { value: "visa", label: "Visa" },
        { value: "financial", label: "Financial" },
        { value: "other", label: "Other" }
    ];
    const allServiceProviders = [
        { value: "tk1", label: "Provider 1" },
        { value: "tk2", label: "Provider 2" },
        { value: "tk3", label: "Provider 3" },
        { value: "tk4", label: "Provider 4" },
        { value: "tk5", label: "Provider 5" }
    ];

    const [allConsents, setAllConsents] = useState([]);

    const getAllERPConsents = async () => {
        try {
            const query = {
                "limit": entriesLimit,
                "skip": skipEntries
            }

            const getERPConsent = await axios.post(`${serverURL}/consentMap/getAllConsents`, query);

            if (getERPConsent.status === 200) {
                const data = await getERPConsent.data;
                setAllConsents(data.consents)
                setTotalEntriesCount(data.total)
                // console.log(data);
            } else {
                console.log(getERPConsent.data);
            }
        } catch (error) {
            console.error("Error fetching ERP consents:", error);
        }
    }


    const getAllInSync = async () => {
        const getERPConsent = await axios.post(`${serverURL}/consentMap/getERPConsent`)
        if (getERPConsent.status === 200) {
            const data = await getERPConsent.data;
            for (let i = 0; i < data.length; i++) {
                const consent = data[i];
                const newConsent = {
                    callingStatus: "",
                    followUpDate: "",
                    serviceType: "",
                    serviceProvider: "",
                    serviceRemarks: "",
                    consentId: "",
                    stdcode: consent.STDCODE,
                    stdid: consent.STDID,
                    name: consent.STDNAME,
                    email: consent.EMAIL,
                    phone: consent.PHONE,
                    consentType: "",
                    consentAnswer: "",
                    application: consent.APPLICATION,
                    ba_COMPANY: consent.BA_COMPANY,
                    ba_STATUS: consent.BA_STATUS,
                    intakeCode: consent.INTAKECODE,
                    status: consent.STATUS,
                    stdloancode: consent.STDLOANCODE,
                    stdname: consent.STDNAME,
                    ststatus: consent.STSTATUS,
                };

                const saveConsent = await axios.post(`${serverURL}/consentMap/addConsent`, newConsent);
                if (saveConsent.status === 200) {
                    console.log(saveConsent.data);
                } else {
                    console.log(saveConsent.data)
                }
            }

        } else {
            console.log(getERPConsent.data);
        }
    }

    useEffect(() => {
        getAllERPConsents();
        getAllInSync()
    }, []);

    useEffect(() => {
        getAllERPConsents()
    }, [entriesLimit, skipEntries]);
    return (
        <>
            <div className="transback h-100 d-flex flex-column p-3">
                <button className='btn text-secondary rounded-pill px-3 py-1 d-flex d-lg-none d-xl-none d-xxl-none align-items-center gap-2' onClick={() => { setShowSideOverlay(true) }}>
                    <MenuIcon />
                </button>
                <div className="headerUserDetails py-1 border-0 d-flex justify-content-between">
                    <span>Student Consent</span>
                    <div className='d-flex gap-2 align-items-center justify-content-center text-dark px-2' style={{ cursor: "pointer" }} title={"Name: " + user.name + "\nEmail: " + user.email}>
                        <i className='fa fa-user'></i>
                        <span>{user.name}</span>
                    </div>
                </div>
                <div className='mt-3 d-flex flex-column gap-2 align-items-start w-100 h-100 overflow-auto'>
                    <table className='table table-yesgermany table-striped table-bordered table-hover m-0'>
                        <thead>
                            <tr>
                                <th className='text-center'>callingStatus</th>
                                <th className='text-center'>followUpDate</th>
                                <th className='text-center'>serviceType</th>
                                <th className='text-center'>serviceProvider</th>
                                <th className='text-center'>serviceRemarks</th>
                                <th className='text-center'>consentId</th>
                                <th className='text-center'>stdcode</th>
                                <th className='text-center'>stdid</th>
                                <th className='text-center'>name</th>
                                <th className='text-center'>email</th>
                                <th className='text-center'>phone</th>
                                <th className='text-center'>consentType</th>
                                <th className='text-center'>consentAnswer</th>
                                <th className='text-center'>application</th>
                                <th className='text-center'>ba_COMPANY</th>
                                <th className='text-center'>ba_STATUS</th>
                                <th className='text-center'>intakeCode</th>
                                <th className='text-center'>status</th>
                                <th className='text-center'>stdloancode</th>
                                <th className='text-center'>stdname</th>
                                <th className='text-center'>ststatus</th>
                                <th className='text-center'>createdAt</th>
                                <th className='text-center'>updatedAt</th>
                            </tr>
                        </thead>
                        <tbody>
                            {

                                allConsents.length > 0 ? allConsents.map((consent, index) => (
                                    <tr key={index}>
                                        <td className='text-center'>{consent.callingStatus}</td>
                                        <td className='text-center'>{consent.followUpDate}</td>
                                        <td className='text-center' style={{ minWidth: "400px" }}>
                                            <Select
                                                className='w-100 text-nowrap'
                                                placeholder="Select Service Type"
                                                // value={serviceTypes}
                                                onChange={() => { }}
                                                autoFocus={false}
                                                isMulti={true}
                                                isSearchable={true}
                                                required={false}
                                                options={allServiceTypes.map((data, key) => {
                                                    return { "value": data.value, "label": data.label }
                                                })}
                                            />
                                        </td>
                                        <td className='text-center' style={{ minWidth: "400px" }}>
                                            <Select
                                                className='w-100'
                                                placeholder="Select Service Provider"
                                                // value={serviceProviders}
                                                onChange={() => { }}
                                                autoFocus={false}
                                                isMulti={true}
                                                isSearchable={true}
                                                required={false}
                                                options={allServiceProviders.map((data, key) => {
                                                    return { "value": data.value, "label": data.label }
                                                })}
                                            />
                                        </td>
                                        <td className='text-center'>{consent.serviceRemarks}</td>
                                        <td className='text-center'>{consent.consentId}</td>
                                        <td className='text-center'>{consent.stdcode}</td>
                                        <td className='text-center'>{consent.stdid}</td>
                                        <td className='text-center'>{consent.name}</td>
                                        <td className='text-center'>{consent.email}</td>
                                        <td className='text-center'>{consent.phone}</td>
                                        <td className='text-center'>{consent.consentType}</td>
                                        <td className='text-center'>{consent.consentAnswer}</td>
                                        <td className='text-center'>{consent.application}</td>
                                        <td className='text-center'>{consent.ba_COMPANY}</td>
                                        <td className='text-center'>{consent.ba_STATUS}</td>
                                        <td className='text-center'>{consent.intakeCode}</td>
                                        <td className='text-center'>{consent.status}</td>
                                        <td className='text-center'>{consent.stdloancode}</td>
                                        <td className='text-center'>{consent.stdname}</td>
                                        <td className='text-center'>{consent.ststatus}</td>
                                        <td className='text-center text-nowrap'>{dayjs(consent.createdAt).format("D MMM YYYY h:mma")}</td>
                                        <td className='text-center text-nowrap'>{dayjs(consent.updatedAt).format("D MMM YYYY h:mma")}</td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan="100%" className='text-center'>No consents found</td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>

                <div className='w-100 mt-2 customBackgroundFilter rounded'>
                    <ConfigProvider
                        theme={{
                            components: {
                                Pagination: {
                                    itemActiveBg: "#faf089",
                                    itemActiveBgDisabled: "yellow",
                                    // itemActiveColorDisabled: "",
                                    // itemBg: "",
                                    // itemInputBg: "",
                                    // itemLinkBg: "",

                                },
                            },
                            token: {
                                // colorBgContainer: "",
                                // colorBgContainerDisabled: "",
                                // colorBgTextActive: "",
                                colorBgTextHover: "rgba(255, 246, 164, 0.73)",
                                // colorBorder: "red",
                                // colorPrimary: "",
                                // colorPrimaryBorder: "#faf089",
                                // colorPrimaryHover: "",
                                // colorText: "",
                                // colorTextDisabled: "",
                                // colorTextPlaceholder: "",
                                // borderRadius: "",
                                // borderRadiusLG: "",
                                // borderRadiusSM: "",
                                // controlHeight: "",
                                // controlOutline: "",
                                // controlOutlineWidth: "",
                                // fontFamily: "",
                                // fontSize: "",
                                // lineHeight: "",
                                margin: 0,
                                // motionDurationMid: "",
                                // paddingXXS: ""
                            }
                        }}
                    >
                        <Pagination defaultCurrent={2} current={currentPageNumber} defaultPageSize={entriesLimit} showSizeChanger={true} showQuickJumper={true} simple={false} disabled={false} total={totalEntriesCount} onChange={(e) => { setCurrentPageNumber(e); setSkipEntries((e - 1) * entriesLimit) }} onShowSizeChange={(page, pageSize) => { setEntriesLimit(pageSize) }} />
                    </ConfigProvider>
                </div>
            </div>
        </>
    )
}

export default Consents